import type {
  EvaluationContextInterceptor,
  EvaluationContextSetter,
  FlagEvaluationAttributes,
} from '@spotify/confidence-flag-evaluation-react';

import { applyImpersonation } from './impersonationContext';
import {
  readEverImpersonatedKeys,
  readImpersonationContext,
  subscribeToImpersonation,
} from './impersonationStore';
import {
  readRealEvaluationAttributes,
  writeRealEvaluationAttributes,
} from './realAttributesStore';

export const impersonateEvaluationContext: EvaluationContextInterceptor = (
  setEvaluationContext: EvaluationContextSetter,
): EvaluationContextSetter => {
  let subscribed = false;

  const impersonate = (
    attributes: FlagEvaluationAttributes,
  ): FlagEvaluationAttributes =>
    applyImpersonation(
      attributes,
      readImpersonationContext(),
      readEverImpersonatedKeys(),
    );

  const ensureReapplyOnImpersonationChange = (): void => {
    if (subscribed) {
      return;
    }
    subscribed = true;
    subscribeToImpersonation(() => {
      const realAttributes = readRealEvaluationAttributes();
      if (realAttributes) {
        setEvaluationContext(impersonate(realAttributes));
      }
    });
  };

  return (attributes: FlagEvaluationAttributes): void => {
    writeRealEvaluationAttributes(attributes);
    ensureReapplyOnImpersonationChange();
    setEvaluationContext(impersonate(attributes));
  };
};
